import { ReactNode, useCallback, useEffect, useState } from "react";
import TableTile from "src/components/TableTile";
import { TableInfo } from "src/components/types";
import "./SimpleTableList.css";
import { canAdminProject, canSeeFeedback } from "src/components/utils";

function SimpleTableList(props: { tables: TableInfo[]; loadMore: () => void }) {
  const [stateTableTiles, setStateTableTiles] = useState<ReactNode[]>([]);

  const fetchProjectData = useCallback(async (projectSlug: string) => {
    return fetch(
      "/api/projects/get-project-detail/" + projectSlug + "?status=none" + "&sessionId=" + sessionStorage.sessionId,
      {
        method: "GET",
      },
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    let projectDataMap: { [key: string]: any } = {};
    let promises: Promise<any>[] = [];

    props.tables.forEach((table) => {
      promises.push(fetchProjectData(table.projectInfo.slug));
    });

    Promise.all(promises).then((results) => {
      results.forEach((data) => {
        if (data) {
          projectDataMap[data.slug] = data;
        }
      });
      setStateTableTiles((oldValue) =>
        props.tables.map((table) => (
          <TableTile
            key={table.tableId}
            tableInfo={table}
            options={projectDataMap[table.projectInfo.slug]?.options || {}}
            showAllOptions={
              canAdminProject(projectDataMap[table.projectInfo.slug]) ||
              canSeeFeedback(projectDataMap[table.projectInfo.slug])
            }
          />
        )),
      );
    });
  }, [props.tables]);

  return (
    <div className="simple-table-list">
      {stateTableTiles.length > 0 ? (
        <div className="table-list-redesign-tiles-container">{stateTableTiles}</div>
      ) : (
        <div className="table-list-redesign-no-tables-message">You have no tables.</div>
      )}
    </div>
  );
}

export default SimpleTableList;
